<template>
  <div id="checkout" class="payuCard">
    <div class="container">
      <div class="card mb-5">
        <div class="card-content">
          <div class="row mb-5">
            <!-- Form --->
            <div class="col align-self-center">
              <div class="logop">
                <img src="img/payu.png">
              </div>
              <div class="mb-3 mt-5">
                <h3 class="mb-3 mt-5">Ingrese sus datos de facturación</h3>
              </div>
              <div class="row justify-content-md-center mb-3">
                <form
                  name="tokenForm"
                  action="https://checkout.payulatam.com/ppp-web-gateway-payu/"
                  method="post"
                  ref="form"
                  class="col-md-6"
                >
                  <input
                    class="mb-3"
                    type="text"
                    name="payerFullName"
                    placeholder="Nombre"
                    ref="Name"
                    v-model="nombre"
                  >
                  <input
                    class="mb-3"
                    type="text"
                    name="buyerEmail"
                    placeholder="E-Mail"
                    ref="email"
                    v-model="email"
                  >
                  <input name="merchantId" type="hidden" value="795295">
                  <input name="accountId" type="hidden" value="802218">
                  <input name="description" type="hidden" v-model="cart.adTitle">
                  <input name="referenceCode" type="hidden" v-model="cart.adKey">
                  <input name="amount" type="hidden" v-model="cart.adCost">
                  <input name="tax" type="hidden" value="0">
                  <input name="taxReturnBase" type="hidden" value="0">
                  <input name="currency" type="hidden" value="MXN">
                  <input name="signature" type="hidden" v-model="signature">
                  <input name="test" type="hidden" value="0">
                  <input
                    name="responseUrl"
                    type="hidden"
                    value="https://pay.gtek.mx/#/successpayu/"
                  >
                  <input
                    name="confirmationUrl"
                    type="hidden"
                    value="https://api.ar.gtek.mx/v1/responsePayU"
                  >
                  <!-- <input name="shippingAddress" type="hidden" value="Puebla">
      <input name="shippingCity" type="hidden" value="Puebla">
      <input name="shippingCountry" type="hidden" value="MX">
                  <input name="telephone" type="hidden" value="2228068678">-->
                  <!-- <input type="submit" value="Enviar">-->
                  <button type="button" class="btn btn-primary btn-sm" @click="sendInfo()">Siguiente</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { servicesAR } from "@/components/services/servicesAR";
import axios from "axios";
export default {
  name: "storeMethod",
  data: () => ({
    newAction: "",
    tcard: "",

    email: "",
    nombre: ""
  }),
  props: {},
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    refNumber() {
      var num = Math.floor(Math.random() * 1000000000000 + 1);
      console.log(this.$store.state.cart.adKey + "-" + num.toString());
      return this.$store.state.cart.adKey + "-" + num.toString();
    },
    signature() {
      const chain =
        "HN192y4cVxJ8cVB6QWywbNmd4k~795295~" +
        this.cart.adKey +
        "~" +
        this.cart.adCost +
        "~MXN";

      return servicesAR.MD5(chain);
    }
  },
  methods: {
    async sendInfo() {
      var that = this;

      console.log(this.$store.state.cart);

      console.log("signature");
      console.log(this.signature);

      this.newAction =
        "https://sandbox.checkout.payulatam.com/ppp-web-gateway-payu/";
      console.log(this.newAction);
      this.showFrame = true;
      this.$nextTick(() => {
        var f = document.forms["tokenForm"];

        console.log(f);
        f.submit();
      });
    }
  },
  created() {
    console.log("RefNumber");
    console.log(this.refNumber);
    window.onmessage = async function(e) {
      var obj = JSON.parse(e.data);
      if (obj.status == "APPROVED") {
        var msg = JSON.stringify({
          success: true,
          adTitle: that.$store.state.cart.adTitle,
          //transactionID: e.data.orderID,
          pType: "4",
          adKey: that.$store.state.cart.adKey
          // data: charge.data
        });
        console.log(msg);
        window.opener.postMessage(msg, "*");
        //window.close();
      } else {
        var msg = JSON.stringify({
          success: false,
          adTitle: that.$store.state.cart.adTitle,
          //transactionID: e.data.orderID,
          pType: "4",
          adKey: that.$store.state.cart.adKey
          // data: charge.data
        });
        console.log(msg);
        window.opener.postMessage(msg, "*");
        //window.close();
      }
    };
  }
};
</script>


